import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class GetAvailableBanksQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_id:Number|String): Promise<any> {
    let res = undefined
    try {
      res = await this.dispatcher.dispatch('get.available.banks', {current_bank_account_id: bank_account_id});
    } catch (error) {
      console.log('Error while getting available banks: ', error);
    }
    this.frontend.availableBanks = res || [];
  }
}